import Pricing6 from './Pricing6'
export default Pricing6
